import { render, staticRenderFns } from "./TipoDispositivo.vue?vue&type=template&id=72804fcd&"
import script from "./TipoDispositivo.vue?vue&type=script&lang=ts&"
export * from "./TipoDispositivo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports